<div
	tabindex="-1"
	class="popup-target"
	cdk-overlay-origin
	#popupOrigin="cdkOverlayOrigin"
	(click)="clicked()"
	(mouseenter)="mousedOver()"
	(mouseleave)="mousedOut()"
	nhaTest="popup-target"
>
	<ng-content select="[popup-target]"></ng-content>
</div>

<ng-template
	cdk-connected-overlay
	[cdkConnectedOverlayOrigin]="popupOrigin"
	[cdkConnectedOverlayHasBackdrop]="isClick"
	[cdkConnectedOverlayOpen]="isOpen"
	cdkConnectedOverlayBackdropClass="mat-overlay-transparent-backdrop"
	(backdropClick)="backdropClicked()"
	[cdkConnectedOverlayOffsetX]="offsetX"
	[cdkConnectedOverlayOffsetY]="offsetY"
	[cdkConnectedOverlayFlexibleDimensions]="true"
	[cdkConnectedOverlayHeight]="popupHeight"
>
	<div
		class="nha-popup-container"
		[ngClass]="{ 'dark-bg': isDarkBG, 'scrollbar': hasScrollbar }"
		[class]="contentClass"
		(mouseover)="popupMousedOver()"
		(mouseleave)="popupMousedOut()"
		nhaTest="popup-content"
	>
		<ng-content select="[popup-content]"></ng-content>
	</div>
</ng-template>
